import { useCallback, useEffect, useState } from 'react';

// At most one template video is audible at a time: claiming sound mutes whoever had it.
let owner = null;
const listeners = new Set();

const setOwner = (id) => {
    owner = id;
    listeners.forEach((l) => l(owner));
};

export const releaseSound = (id) => { if (owner === id) setOwner(null); };

export function useSound(id) {
    const [current, setCurrent] = useState(owner);

    useEffect(() => {
        listeners.add(setCurrent);
        setCurrent(owner);
        return () => {
            listeners.delete(setCurrent);
            releaseSound(id);
        };
    }, [id]);

    const on = current === id;
    const toggle = useCallback(() => setOwner(owner === id ? null : id), [id]);
    const claim = useCallback(() => setOwner(id), [id]);

    return { on, toggle, claim };
}

export const isSoundOwner = (id) => owner === id;
